import CapegoImporter from "./capego/CapegoImporter.js";
import EconomicImporter from "./economic/EconomicImporter.js";
import FortnoxExtendedImporter from "./fortnox/FortnoxExtendedImporter.js";
import FortnoxImporter from "./fortnox/FortnoxImporter.js";
import OpenIntegrationImporter from "./oi/OpenIntegrationImporter.js";
import PowerOfficeGoImporter from "./powerofficego/PowerOfficeGoImporter.js";
import QuickbooksImporter from "./quickbooks/QuickbooksImporter.js";
import SaftImporter from "./saft/SaftImporter.js";
import SieImporter from "./sie/SieImporter.js";
import TfsoImporter from "./tfso/TfsoImporter.js";
import TripletexImporter from "./tripletex/TripletexImporter.js";
import TwinfieldIsaasImporter from "./isaas/TwinfieldIsaasImporter.js";
import UnicontaIsaasImporter from "./isaas/UnicontaIsaasImporter.js";
import XeroImporter from "./xero/XeroImporter.js";
import XledgerImporter from "./xledger/XledgerImporter.js";

let instance;

/**
 * Factory used to retrieve an Importer based on an integration type.
 * It implements a Singleton pattern via the `instance` static method.
 */
export default class ImporterFactory {
	allClasses() {
		return [
			SieImporter,
			OpenIntegrationImporter,
			SaftImporter,
			TfsoImporter,
			TripletexImporter,
			XledgerImporter,
			FortnoxImporter,
			FortnoxExtendedImporter,
			XeroImporter,
			QuickbooksImporter,
			EconomicImporter,
			PowerOfficeGoImporter,
			TwinfieldIsaasImporter,
			UnicontaIsaasImporter,
			CapegoImporter,
		];
	}

	findClassFromIntegrationType(integrationType) {
		return this.allClasses().find((each) =>
			each.matchIntegrationType(integrationType),
		);
	}

	static instance() {
		instance ||= new this();

		return instance;
	}
}
